// ==================== SERVICIO DE SECCIONES DE MATERIALES ====================
// Este servicio maneja todas las llamadas API relacionadas con secciones de materiales

import api from './api';

const seccionesMaterialesService = {
  /**
   * Obtener todas las secciones de materiales del proyecto actual
   */
  obtenerSecciones: async (incluirInactivas = false) => {
    try {
      const response = await api.get('/secciones-materiales', {
        params: { incluirInactivas }
      });
      return response.data.secciones;
    } catch (error) {
      console.error('❌ Error al obtener secciones de materiales:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Obtener una sección de material específica por ID
   */
  obtenerSeccionPorId: async (seccionId) => {
    try {
      const response = await api.get(`/secciones-materiales/${seccionId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener sección de material:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Crear una nueva sección de material
   */
  crearSeccion: async (datosSeccion) => {
    try {
      const response = await api.post('/secciones-materiales', datosSeccion);
      return response.data.seccion;
    } catch (error) {
      console.error('❌ Error al crear sección de material:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Actualizar una sección de material existente
   */
  actualizarSeccion: async (seccionId, datosActualizados) => {
    try {
      const response = await api.put(`/secciones-materiales/${seccionId}`, datosActualizados);
      return response.data.seccion;
    } catch (error) {
      console.error('❌ Error al actualizar sección de material:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Eliminar una sección de material
   */
  eliminarSeccion: async (seccionId) => {
    try {
      const response = await api.delete(`/secciones-materiales/${seccionId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error al eliminar sección de material:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Obtener estadísticas de una sección de material
   */
  obtenerEstadisticas: async (seccionId) => {
    try {
      const response = await api.get(`/secciones-materiales/${seccionId}/estadisticas`);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener estadísticas:', error.response?.data || error.message);
      throw error;
    }
  },

  /**
   * Reordenar secciones de materiales
   */
  reordenarSecciones: async (ordenSecciones) => {
    try {
      const promesas = ordenSecciones.map((seccion, index) => 
        api.put(`/secciones-materiales/${seccion.id}`, { orden: index })
      );
      
      await Promise.all(promesas);
      return true;
    } catch (error) {
      console.error('❌ Error al reordenar secciones de materiales:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default seccionesMaterialesService;
